import { Button, Grid, MenuItem, Popover } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { Form } from 'react-final-form';
import { LoadingButton } from '@mui/lab';

import SelectField from 'common/forms/SelectField';
import TextField from 'common/forms/TextField';
import { filterEvents } from 'store/thunks/eventThunks';
import { validateMinLength } from 'common/forms/formValidations';
import { map } from 'lodash';

const EventsFilterButton = () => {
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);

  const filter = useSelector(({ criticalEvents: { events } }) => events.filter);

  const loading = useSelector(({ criticalEvents: { events } }) => events.eventLoading);

  const criticalEventTypes = useSelector(({ criticalEvents: { eventTypes } }) => eventTypes);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const popoverId = anchorEl ? 'CriticalEvents-eventsFilterButton-Popover' : undefined;

  const handleApplyFilter = (formData) => {
    setAnchorEl(null);

    dispatch(
      filterEvents({
        filter: {
          ...filter,
          ...formData,
        },
      })
    );
  };

  return (
    <>
      <Button
        sx={{ height: 33 }}
        variant='outlined'
        color='secondary'
        onClick={handleOpen}
        aria-describedby={popoverId}
      >
        Filters
      </Button>

      <Popover
        id={popoverId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Grid container sx={{ p: 1.5, width: 325 }} spacing={2} direction='column'>
          <Grid item>
            <Form
              initialValues={filter}
              onSubmit={handleApplyFilter}
              render={({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Event Actor Name'
                      name='pomUserName'
                      id='CriticalEvents-eventsFilterButton-pomUserName-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <SelectField
                      label='Event Type'
                      name='eventType'
                      id='CriticalEvents-eventsFilterButton-eventType-dropdown'
                    >
                      <MenuItem sx={{ fontSize: '10px' }} value=''>
                        All
                      </MenuItem>
                      {map(criticalEventTypes, (eventType) => (
                        <MenuItem
                          value={eventType}
                          key={eventType}
                          sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontSize: '15px',
                            width: '250px',
                          }}
                        >
                          {eventType.replace(/_/g, ' ')}
                        </MenuItem>
                      ))}
                    </SelectField>
                  </Grid>

                  <Grid container justifyContent='flex-end'>
                    <LoadingButton
                      loading={loading}
                      type='submit'
                      variant='contained'
                      disabled={invalid}
                    >
                      Apply
                    </LoadingButton>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default EventsFilterButton;
